import BaseContainer from "@base/container/BaseContainer"
import * as PIXI from "pixi.js";
import Config from "../config/Config";
import ReelsConfig from "../config/ReelsConfig";
import {Signals} from "@/Imports";
import SpineRepeatedAnimation from "@base/spineAnimation/SpineRepeatedAnimation";

export default class AnticipationContainer extends BaseContainer {

  constructor(data) {
    super(data);

    this.offsetY = 0;
    this.offsetX = 0;

    this.columnWidth = 190;

    this.init();
  }

  init() {
    this.cache = {};
  }

  getByColumn(columnIndex) {
    if (!this.cache[columnIndex]) {
      this.cache[columnIndex] = this.createAnticipation(columnIndex);
    }
    return this.cache[columnIndex];
  }

  playAnticipation(columnIndex) {
    const timeShow = 1;

    const anticipation = this.getByColumn(columnIndex);
    anticipation.alpha = 1;
    anticipation.start ([ 'suspense_Start', 'suspense_idle', 'suspense_stop' ], [ 1, 20, 1 ], timeShow)
  }

  stopAnticipation() {
    if (Object.values(this.cache)) {
      Object.values(this.cache).forEach(anticipation => {
        anticipation.stop();
        anticipation.alpha = 0;
      });
    }
  }

  createAnticipation(columnIndex) {
    const anticipation = new SpineRepeatedAnimation('suspense_effect');
    anticipation.x = Config.pattern.reels.reels[columnIndex].x + this.offsetX;
    anticipation.y = 460;
    this.addChild(anticipation);
    return anticipation;
  }
}
